import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { FireIcon, WrenchScrewdriverIcon, BeakerIcon, Cog6ToothIcon, PaintBrushIcon } from '@heroicons/react/24/solid';

const services = [
  {
    title: "Heat Treatment",
    desc: "Enhance material strength, hardness, and wear resistance using advanced heat treatment technologies including annealing, quenching, tempering, and carburizing.",
    icon: FireIcon,
    color: "text-orange-500",
  },
  {
    title: "Bending & Forming",
    desc: "Utilizing automated bending machines, we ensure accurate shaping of metal sheets, pipes, and components—optimized for stress resistance and dimensional precision.",
    icon: WrenchScrewdriverIcon,
    color: "text-blue-500",
  },
  {
    title: "Test Laboratory",
    desc: "Our in-house metallurgical test lab is equipped for microstructure analysis, hardness testing, tensile & fatigue testing, and non-destructive testing (NDT).",
    icon: BeakerIcon,
    color: "text-green-500",
  },
  {
    title: "Fabrication & Machining",
    desc: "From design to delivery, we offer comprehensive fabrication and CNC machining services. Our expert consultants provide material selection, weldability guidance, surface treatments, and design optimization.",
    icon: Cog6ToothIcon,
    color: "text-purple-500",
  },
  {
    title: "Advanced Ovens & Painting Booths",
    desc: "Our finishing line includes temperature-controlled industrial ovens and dust-free painting booths for high-performance coatings including powder coating and industrial paints.",
    icon: PaintBrushIcon,
    color: "text-red-500",
  },
];

const OurServices: React.FC = () => {
  return (
    <section className="py-20 px-4 md:px-20 bg-blue-50 relative overflow-hidden">
  <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-blue-900">
    🛠️ Our Services
  </h2>

  {/* Desktop Grid */}
  <div className="hidden md:grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
    {services.map((service, index) => (
      <motion.div
        key={index}
        className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-2xl transition transform hover:-translate-y-2"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: index * 0.2 }}
      >
        <service.icon className={`w-12 h-12 mx-auto mb-4 ${service.color}`} />
        <h3 className="text-xl font-semibold text-blue-900 mb-2">{service.title}</h3>
        <p className="text-gray-600 text-sm">{service.desc}</p>
      </motion.div>
    ))}
  </div>

  {/* Mobile Horizontal Swiper */}
  <div className="block md:hidden">
    <Swiper
      modules={[Autoplay]}
      spaceBetween={20}
      slidesPerView={1.2}
      autoplay={{ delay: 4000 }}
      speed={2500}
      loop={true}
    >
      {services.map((service, index) => (
        <SwiperSlide key={index}>
          <motion.div
            className="bg-white rounded-xl shadow-lg p-6 text-center"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
          >
            <service.icon className={`w-12 h-12 mx-auto mb-4 ${service.color}`} />
            <h3 className="text-xl font-semibold text-blue-900 mb-2">{service.title}</h3>
            <p className="text-gray-600 text-sm">{service.desc}</p>
          </motion.div>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
</section>

  );
};

export default OurServices;
